import { render, staticRenderFns } from "./MerchantCardGrid.vue?vue&type=template&id=84cef00c&scoped=true"
import script from "./MerchantCardGrid.vue?vue&type=script&lang=js"
export * from "./MerchantCardGrid.vue?vue&type=script&lang=js"
import style0 from "./MerchantCardGrid.vue?vue&type=style&index=0&id=84cef00c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cef00c",
  null
  
)

export default component.exports